/**
 * Shared helpers for formatting user identity in the Topbar.
 * Single source of truth — imported by ProfileMenu and MobileDrawer.
 */

/**
 * Returns a 1-2 character initials string for the avatar badge.
 * Priority: first+last name initials → username initials → '?'
 */
export function buildInitials(firstName, lastName, username) {
    const safe = (s) => (typeof s === 'string' ? s.trim() : '');
    const f = safe(firstName);
    const l = safe(lastName);
    if (f || l) return ((f[0] || '') + (l[0] || '')).toUpperCase() || '?';
    const u = safe(username);
    if (!u) return '?';
    const parts = u.split(/[\s._-]+/).filter(Boolean);
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    return u.slice(0, 2).toUpperCase();
}

/**
 * Returns the display name shown next to the avatar.
 * Priority: "First Last" → username → ''
 */
export function buildDisplayName(firstName, lastName, username) {
    const full = [firstName, lastName].filter(Boolean).join(' ').trim();
    return full || username || '';
}
